import { createContext, useContext, useEffect, useState } from "react";
import api, { getToken, setToken } from "@/lib/api";
import { TERMS_VERSION } from "@/content/terms";

const Ctx = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [ready, setReady] = useState(false);

  useEffect(() => {
    if (!getToken()) { setUser(false); setReady(true); return; }   // signed-out visitors: no /auth/me round-trip (and no 401 in the console)
    api.get("/auth/me").then((r) => setUser(r.data)).catch((e) => { if (e?.response?.status === 403) { sessionStorage.setItem("changeos_auth_notice", e.response.data?.detail || "You no longer have access to that organisation."); setToken(null); } setUser(false); }).finally(() => setReady(true));
  }, []);

  const login = async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    setToken(data.token); setUser(data.user); return data.user;
  };
  const register = async (name, email, password, carry, partner = false) => {
    const { data } = await api.post("/auth/register", { name, email, password, carry: carry || null, partner, terms_version: TERMS_VERSION });
    setToken(data.token); setUser(data.user); return data;
  };
  const acceptInvite = async (token, name, password) => {
    const { data } = await api.post("/auth/accept-invite", { token, name, password, terms_version: TERMS_VERSION });
    setToken(data.token); setUser(data.user); return data.user;
  };
  const PERMS = { viewer: ["read"], approver: ["read", "approve"], sponsor: ["read", "approve"], partner: ["read", "approve", "write", "ai", "invite"], change_manager: ["read", "approve", "write", "ai", "invite"], owner: ["read", "approve", "write", "ai", "invite", "manage_org"] };
  const can = (action) => !!user && (PERMS[user.role] || []).includes(action);
  const logout = async () => {
    await api.post("/auth/logout").catch(() => {});
    setToken(null); setUser(false);
  };
  const markOnboarded = async () => {
    if (user?.onboarding_seen) return;
    const { data } = await api.post("/auth/onboarding-seen");
    setUser((u) => ({ ...(u || {}), ...data }));
  };
  return <Ctx.Provider value={{ user, ready, login, register, logout, markOnboarded, acceptInvite, can, setUser }}>{children}</Ctx.Provider>;
}

export const useAuth = () => useContext(Ctx);
export const landingFor = (u) => (u?.role === "sponsor" ? "/app/sponsor" : "/app");
